/**
 * Utility for conditionally loading Google AdSense
 * Only loads on pages with substantial content to comply with AdSense policies
 */

const ADSENSE_CLIENT_ID = 'ca-pub-7171105214023294';
let adsenseLoaded = false;

/**
 * Pages that should have AdSense enabled (content-rich pages)
 */
const ALLOWED_PAGES = [
  '/',
  '/salary-to-hourly',
  '/student-loan-estimator',
  '/take-home-table',
  '/how-to-use',
  // /about excluded - low-value for ads; legal/contact already excluded
  // Dynamic salary pages are handled separately
];

/**
 * Check if current page should have AdSense
 */
export const shouldLoadAdSense = (pathname) => {
  // Check exact matches
  if (ALLOWED_PAGES.includes(pathname)) {
    return true;
  }
  
  // Check if it's a valid salary page (e.g., /salary/40000)
  if (pathname.startsWith('/salary/')) {
    const amount = parseInt(pathname.split('/')[2]);
    // Only allow valid salary amounts
    return !isNaN(amount) && amount > 0 && amount <= 1000000;
  }
  
  // Exclude legal and contact pages
  return false;
};

/**
 * Load AdSense script dynamically
 */
export const loadAdSense = () => {
  if (adsenseLoaded) {
    return;
  }

  // Check if script already exists
  if (document.querySelector(`script[src*="adsbygoogle.js"]`)) {
    adsenseLoaded = true;
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`;
  script.crossOrigin = 'anonymous';
  script.onload = () => {
    adsenseLoaded = true;
  };
  
  document.head.appendChild(script);
};

/**
 * Remove AdSense script if it exists
 * Note: Once AdSense is loaded, ads may still appear until page reload
 * This prevents new ads from initializing on excluded pages
 */
export const removeAdSense = () => {
  const script = document.querySelector(`script[src*="adsbygoogle.js"]`);
  if (script) {
    script.remove();
    adsenseLoaded = false;
  }
  
  // Remove any ad containers that might have been created
  // This helps prevent ads from showing on excluded pages
  const adContainers = document.querySelectorAll('[id*="google_ads"], [class*="adsbygoogle"]');
  adContainers.forEach(container => {
    // Only remove if it's an auto-generated ad container
    if (container.id && container.id.includes('google_ads')) {
      container.remove();
    }
  });
};

